/**
 * CAPTURE ACK — what the agent is told when the visitor finishes a
 * capture (form submit, slot booking).
 *
 * Found live in Beam 2026-09-04: she offered the form, the visitor
 * filled it in, and she carried on as if it were empty. No deployment
 * ever told the agent — the text views only LOOKED acknowledged because
 * the receipt sits in the thread. In a live call the bot now gets a
 * visitor-action app message (bot.py visitor_notes) and speaks the ack.
 * Pure builders so the wire shape is unit-tested.
 */

export type CaptureAck = {
  kind: 'form_submitted' | 'meeting_booked';
  label: string;
};

/** The contact / capture form landed. */
export function formSubmittedAck(email?: string | null): CaptureAck {
  const e = email?.trim();
  return { kind: 'form_submitted', label: e ? `contact details (${e})` : 'contact details' };
}

/** A slot booking landed; `when` is the time as the visitor saw it. */
export function meetingBookedAck(when: string, durationMinutes: number): CaptureAck {
  return { kind: 'meeting_booked', label: `${when} (${durationMinutes} min)` };
}
